export enum HaptikLaunchMessage {
  HaptikFibreAssist = 'HaptikFibreAssist',
  HaptikChatToAgent = 'Chat to an agent',
}
